var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasSelectedItems)?_c('footer',{staticClass:"search__footer"},[_c('a',{staticClass:"search__clear-link",attrs:{"href":"#"},on:{"click":function($event){_vm.handleClear($event)}}},[_c('icon',{attrs:{"link":"","type":"times"}}),_vm._v("\n    Rensa alla val\n  ")],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbd60a9c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search/SearchClear.vue
// module id = 653
// module chunks = 1